module.exports = __webpack_public_path__ + "static/microsoft-surface-book@3x-a6a95bb8a11c2238c04011bba84dd427.png";